import {
  DtoProjectType,
  type DtoProjectType as DtoProjectTypeValue,
} from '@/shared/constants';

const key = 'remotion-editor-starter.linking-enabled';
const agentVideoCaptionKey = `${key}.agent-video-caption`;

export const DEFAULT_LINKING_ENABLED = true;
export const DEFAULT_AGENT_VIDEO_CAPTION_LINKING_ENABLED = false;

const getLinkingPreference = (projectType?: DtoProjectTypeValue | null) => {
  if (projectType === DtoProjectType.agentVideoCaption) {
    return {
      key: agentVideoCaptionKey,
      defaultValue: DEFAULT_AGENT_VIDEO_CAPTION_LINKING_ENABLED,
    };
  }

  return {
    key,
    defaultValue: DEFAULT_LINKING_ENABLED,
  };
};

export const loadLinkingEnabled = (
  projectType?: DtoProjectTypeValue | null,
) => {
  if (typeof localStorage === 'undefined') {
    return getLinkingPreference(projectType).defaultValue;
  }

  const preference = getLinkingPreference(projectType);
  const value = localStorage.getItem(preference.key);
  if (value === null) {
    return preference.defaultValue;
  }
  return value === 'true';
};

export const saveLinkingEnabled = (
  enabled: boolean,
  projectType?: DtoProjectTypeValue | null,
) => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(
    getLinkingPreference(projectType).key,
    enabled.toString(),
  );
};
